module.exports = __webpack_public_path__ + "img/t4-i10.0c42cd21.jpg";